import { render, staticRenderFns } from "./control-left.vue?vue&type=template&id=2fc56f7e&"
import script from "./control-left.vue?vue&type=script&lang=js&"
export * from "./control-left.vue?vue&type=script&lang=js&"
import style0 from "./control-left.vue?vue&type=style&index=0&id=2fc56f7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports